class ProfileMenu {
  /**
   * Base state
   */
  _state = {
    open: false,
    scrollTop: 0,
  };

  constructor() {
    this._profileToggle = document.querySelector('.user-toggle');
    this._profileMenu = document.getElementById('js-profile-popover');

    this.initEventListeners();
  }

  initEventListeners() {
    this._profileToggle.addEventListener('click', this.checkState.bind(this));
  }

  checkState() {
    /* eslint-disable no-unused-expressions */
    this._state.open ? this.closeProfileMenu() : this.openProfileMenu();
  }

  openProfileMenu() {
    this._profileMenu.classList.add('is-visible');
    this.setState();
  }

  closeProfileMenu() {
    this._profileMenu.classList.remove('is-visible');
    this.setState();
  }

  setState() {
    this._state.open = !this._state.open;
  }
}

export default ProfileMenu;
